// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as VehicleRepoConfig from "./VehicleRepoConfig.bs.js";

var dummyVehicleTypes = {
  "vehicle_types": [
    {
      "vehicle_id": 1,
      "type": "Tata Ace",
      "name": "Tata Ace"
    },
    {
      "vehicle_id": 2,
      "type": "Tata 407",
      "name": "Tata 407"
    },
    {
      "vehicle_id": 91,
      "type": "3 Wheeler",
      "name": "3 Wheeler"
    },
    {
      "vehicle_id": 96,
      "type": "Ace Helper",
      "name": "Ace (Helper)"
    },
    {
      "vehicle_id": 97,
      "type": "2 Wheeler",
      "name": "2 Wheeler"
    },
    {
      "vehicle_id": 1,
      "type": "3 Wheeler Helper",
      "name": "3 Wheeler (Helper)"
    },
    {
      "vehicle_id": 104,
      "type": "Tata Ace-Outstation",
      "name": "Tata Ace"
    },
    {
      "vehicle_id": 108,
      "type": "Tata 407-Outstation",
      "name": "Tata 407"
    },
    {
      "vehicle_id": 109,
      "type": "Pickup / 8ft 1Ton",
      "name": "8ft 1Ton"
    },
    {
      "vehicle_id": 110,
      "type": "Pickup / 8ft 1.3Ton",
      "name": "8ft Pickup"
    },
    {
      "vehicle_id": 111,
      "type": "Pickup / 8ft 1Ton-Outstation",
      "name": "8ft 1Ton"
    },
    {
      "vehicle_id": 112,
      "type": "Pickup / 8ft 1.3Ton-Outstation",
      "name": "8ft Pickup"
    }
  ]
};

function fetchVehicleTypes(_geoRegionId, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyVehicleTypes
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(VehicleRepoConfig.VehicleTypesResponseConverter.execute, result);
                        });
            });
}

function useVehicleTypes(geo_region_id, country) {
  var match = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var setVehcileTypes = match[1];
  var refetch = function (geo_region_id) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return fetchVehicleTypes(geo_region_id, country);
                }), (function (data) {
                  return Curry._1(setVehcileTypes, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setVehcileTypes, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          refetch(geo_region_id);
          
        }), []);
  return [
          match[0],
          refetch
        ];
}

var VehicleRepo = {
  dummyVehicleTypes: dummyVehicleTypes,
  fetchVehicleTypes: fetchVehicleTypes,
  useVehicleTypes: useVehicleTypes
};

export {
  VehicleRepo ,
  
}
/* react Not a pure module */
